import { KeycloakService } from '../../services/keycloak.service'

export default {
    name: 'Footer',

    computed: {
        isBookingAgent() {
            return KeycloakService.isBookingAgent()
        }
    },

    methods: {
        getProfileUrl() {
            return `${process.env.VUE_APP_KEYCLOAK_AUTH_URL}/realms/${process.env.VUE_APP_KEYCLOAK_REALM}/account`
        }
    }
}
